export default __webpack_public_path__ + "static/Pala_5-9751652ab2e000a9131c85561a381513.png";